// styles.ts
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { Colors } from '../../../../../assets/styles';

const useStyles = makeStyles((theme: Theme) => ({
  description: {
    color: `${Colors.Blue} !important`,
    fontSize: '14px !important',
    borderBottom: `1px solid ${Colors.Gray5}`,
    paddingBottom: '24px !important',
  },
  subDescription: {
    color: `${Colors.Blue} !important`,
    fontSize: '24px !important',
    paddingTop: 24,
    paddingBottom: 24,
  },
  header: {
    paddingTop: 24,
  },
}));

export default useStyles;